import { createWrapperInitializer as createWrapperInitializer$1 } from './server.js';
import { createWrapperInitializer as createWrapperInitializer$2 } from './client.js';

let wrapperInitializer;
if (typeof window === 'undefined') {
  wrapperInitializer = createWrapperInitializer$1;
} else {
  wrapperInitializer = createWrapperInitializer$2;
}
const createWrapperInitializer = wrapperInitializer;

export { createWrapperInitializer };
